<template>
  <div class="carnot-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$η = 1 - T_low/T_high$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage light-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>当前状态</label>
            <span class="val">{{ stepNames[currentStep] || '准备就绪' }}</span>
          </div>
          <div class="hud-item orange">
             <label>热机效率 η</label>
             <span class="val">{{ efficiency.toFixed(1) }}%</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 400 240" preserveAspectRatio="xMidYMid meet">
          <!-- P-V 图坐标轴 -->
          <line x1="50" y1="20" x2="50" y2="200" stroke="#1e293b" stroke-width="2" marker-end="url(#arr-v)" />
          <line x1="50" y1="200" x2="350" y2="200" stroke="#1e293b" stroke-width="2" marker-end="url(#arr-h)" />
          <text x="350" y="215" text-anchor="end" font-size="10">体积 V</text>
          <text x="40" y="30" text-anchor="end" font-size="10" transform="rotate(-90 40 30)">压强 P</text>

          <!-- 卡诺循环 P-V 曲线绘制 -->
          <path :d="cyclePath" fill="rgba(245, 158, 11, 0.1)" stroke="#f59e0b" stroke-width="3" />
          
          <!-- 当前活塞气缸演示 -->
          <g transform="translate(280, 50)">
             <rect x="0" y="0" width="60" height="100" fill="none" stroke="#64748b" stroke-width="2" />
             <rect x="4" :y="pistonY" width="52" height="10" fill="#334155" />
             <text x="30" y="115" text-anchor="middle" font-size="10" fill="#64748b">工作物质</text>
             <line v-if="currentStep === 0" x1="0" y1="100" x2="60" y2="100" stroke="#f43f5e" stroke-width="4" />
             <line v-if="currentStep === 2" x1="0" y1="100" x2="60" y2="100" stroke="#3b82f6" stroke-width="4" />
          </g>

          <!-- 当前轨迹点 -->
          <circle :cx="activePoint.x" :cy="activePoint.y" r="6" fill="#f43f5e" />
        </svg>

        <div class="physics-caption">
          <strong>循环逻辑：</strong>等温膨胀时吸收热量，绝热膨胀时依靠内能做功，随后在低温下等温压缩并绝热回归。<strong>效率仅由高低温差决定。</strong>
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">调节高/低温热源</span></div>
           <div class="flex-row gap-6">
              <div class="flex-1">
                 <label class="s-label">高温 T_high (K)</label>
                 <el-slider v-model="Th" :min="400" :max="800" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">低温 T_low (K)</label>
                 <el-slider v-model="Tl" :min="200" :max="400" size="small"></el-slider>
              </div>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'CarnotCycleViz',
  data() {
    return {
      Th: 600,
      Tl: 300,
      t: 0,
      currentStep: 0,
      stepNames: ['1. 等温膨胀 (吸热)', '2. 绝热膨胀', '3. 等温压缩 (放热)', '4. 绝热压缩']
    }
  },
  computed: {
    efficiency() { return (1 - this.Tl / this.Th) * 100; },
    cyclePath() {
       // P=1/V 及其变体，模拟四段路径
       return `M 80,60 Q 150,80 220,130 Q 180,160 120,180 Q 90,140 80,60`;
    },
    activePoint() {
       const progress = (Math.sin(this.t) + 1) / 2;
       // 简易映射循环点
       this.currentStep = Math.floor(progress * 4);
       return { x: 80 + progress * 140, y: 60 + progress * 70 };
    },
    pistonY() {
       const progress = (Math.sin(this.t) + 1) / 2;
       return 80 - progress * 60;
    }
  },
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
       requestAnimationFrame(this.animate);
       this.t += 0.02;
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.carnot-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.flex-row { display: flex; gap: 20px; } .flex-1 { flex: 1; }
.s-label { font-size: 11px; color: #64748b; font-weight: 800; display: block; }
</style>
